import { InputType } from 'config'

export const getLinkConfigurationFields = () => {
  const rlt: Record<string, InputType> = {
    instructionAssetVerification: {
      title: '',
      inputType: 'text',
      type: 'text',
      error: '',
      span: 3,
      rows: 2,
    },
  }

  return rlt
}
